/* Product Form — Alpine.js component */
document.addEventListener('alpine:init', () => {
  Alpine.data('productForm', (config) => ({
    productId: config.productId,
    productUrl: config.productUrl,
    selectedVariantId: config.initialVariantId,
    selectedOptions: [...config.initialOptions],
    price: config.price,
    compareAtPrice: config.compareAtPrice,
    available: config.available,
    featuredMediaId: config.featuredMediaId,
    isPreorder: Boolean(config.isPreorder),
    sellingPlanId: config.sellingPlanId,
    isLoading: false,
    addError: null,
    variants: [],

    init() {
      const variantsEl = this.$root.querySelector('[data-product-variants]');
      if (variantsEl) {
        try {
          this.variants = JSON.parse(variantsEl.textContent);
        } catch (e) {
          console.error('Failed to parse variants:', e);
        }
      }

      // Set initial variant from URL
      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get('variant');
      if (variantId) {
        const variant = this.variants.find(v => v.id == variantId);
        if (variant) {
          this.selectedVariantId = variant.id;
          this.selectedOptions = [...variant.options];
          this.price = variant.price;
          this.compareAtPrice = variant.compare_at_price || 0;
          this.available = variant.available;
        }
      }
    },

    selectOption(index, value) {
      this.selectedOptions[index] = value;
      this.matchVariant();
    },

    matchVariant() {
      const matched = this.variants.find(variant =>
        variant.options.every((opt, i) => opt === this.selectedOptions[i])
      );

      if (matched) {
        this.selectedVariantId = matched.id;
        this.price = matched.price;
        this.compareAtPrice = matched.compare_at_price || 0;
        this.available = matched.available;

        // Update URL
        const url = new URL(window.location);
        url.searchParams.set('variant', matched.id);
        window.history.replaceState({}, '', url);

        // Dispatch events
        window.dispatchEvent(new CustomEvent('variant-changed', {
          detail: { productId: this.productId, variant: matched }
        }));

        if (matched.featured_media) {
          this.featuredMediaId = matched.featured_media.id;
          window.dispatchEvent(new CustomEvent('variant-media-change', {
            detail: { mediaId: matched.featured_media.id }
          }));
        }
      } else {
        // An impossible option combination must never retain an earlier variant.
        this.selectedVariantId = null;
        this.available = false;
        this.compareAtPrice = 0;
      }
    },

    // Display-only abbreviation for months sizes: "0-3 months" -> "3M".
    // Non-month values (e.g. colors) are returned unchanged.
    sizeLabel(value) {
      if (!value) return value;
      if (!/month|mes/i.test(value)) return value;
      const head = value.split(' ')[0];
      const parts = head.split('-');
      return parts[parts.length - 1] + 'M';
    },

    isOptionAvailable(optionIndex, value) {
      const testOptions = [...this.selectedOptions];
      testOptions[optionIndex] = value;

      return this.variants.some(variant =>
        variant.available &&
        variant.options.every((opt, i) => {
          if (i === optionIndex) return opt === value;
          if (i < optionIndex) return opt === testOptions[i];
          return true;
        })
      );
    },

    async addToCart() {
      if (!this.selectedVariantId || !this.available || this.isLoading) return;

      this.isLoading = true;
      this.addError = null;
      const quantity = parseInt(this.$root.querySelector('.quantity-input__field')?.value) || 1;

      try {
        const item = {
          id: this.selectedVariantId,
          quantity
        };

        if (this.isPreorder && this.sellingPlanId) {
          item.selling_plan = this.sellingPlanId;
        }

        await CartAPI.addToCart([item]);
        const cart = await CartAPI.getCart();
        if (!cart.items || !cart.items.some(line => String(line.id) === String(this.selectedVariantId))) {
          throw new Error((window.cartStrings && window.cartStrings.addError) || 'We couldn\'t add this to your cart. Try again or pick another size.');
        }
        Alpine.store('cart').updateFromCart(cart);
        Alpine.store('cart').open();
        try { if (window.clarity) window.clarity('event', 'add_to_cart'); } catch (e) {}
      } catch (error) {
        console.error('Add to cart error:', error);
        this.addError = error.message || (window.cartStrings && window.cartStrings.addError) || 'We couldn\'t add this to your cart. Try again or pick another size.';
      } finally {
        this.isLoading = false;
      }
    }
  }));
});
